import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { NotificationService } from "../component/notification/notification.service";

@Injectable({
    providedIn: 'root'
})

export class ProductUOMConversionsService {

    constructor(private http: HttpClient, private notificationService: NotificationService) {

    }

    getProductUOMConversion(product: string, productType: string, fromUOM: string, toUOM: string) {
        return this.http.get<any>(environment.apiBaseUrl + `productUOMConversions/GetProductUOMConversion?product=${product}&productType=${productType}&fromUOM=${fromUOM}&toUOM=${toUOM}`);
    }
}